import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import apiOrderCall from 'apps/investment/apiCalls/order';
import apiOrderDetail from 'apps/investment/apiCalls/order/detail-new';
import apiUpdateOrder from 'apps/investment/apiCalls/order/update';
import { DynamicFilterForm } from 'common/dynamic-filter-form';
import { EditPage } from 'common/ui/AdminCRUD/page';
import { DetailPage, ListPage } from 'common/ui/admin-CRUD/page';
import Loading from 'common/ui/loading';
import { useFetchApiGet } from 'hooks/api';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Form from './Form';
import { columnsGenerator, filterConfig } from './config';
import ItemDetail from './detail';
import { UpdateForm } from './update-form';

export const InvestmentOrderListPage = () => {
  return (
    <ListPage
      title="All Fund Orders"
      columnsGenerator={columnsGenerator}
      FilterForm={() => <DynamicFilterForm fields={filterConfig} />}
      apiCall={apiOrderCall}
    />
  );
};

export const InvestmentOrderEditPage = props => (
  <EditPage
    title="Edit Fund Order"
    apiCall={apiOrderCall}
    listUrl={`/investment/fund-orders`}
    ItemForm={Form}
    resourceName="data"
    {...props}
  />
);

export const InvestmentOrderDetailPage = props => (
  <DetailPage
    title="Fund Order"
    apiCall={apiOrderCall}
    listUrl={`/investment/fund-orders`}
    ItemDetail={ItemDetail}
    resourceName="data"
    {...props}
  />
);

export const InvestmentOrderUpdatePage = () => {
  const { id } = useParams();
  const {
    data,
    isLoading,
    error,
    load,
    refetch,
  } = useFetchApiGet(apiOrderDetail, { resourceName: 'data' });

  useEffect(() => {
    if (id) load({ id });
  }, [id]);

  const { mutate: updateOrder, isPending: isSubmitting } = useMutation({
    // Reuse the existing apiCall wrapper, but let TanStack manage the mutation typing.
    mutationFn: (params: any) => apiUpdateOrder.queryFn(params),
    onSuccess: () => {
      refetch();
      message.success('Cập nhật thành công');
    },
  });

  const handleSubmit = (values: any) => {
    updateOrder({ id, ...values });
  };

  if (isLoading) return <Loading />;
  if (error) return <div>Error: {JSON.stringify(error)}</div>;
  return (
    <UpdateForm
      onSubmit={handleSubmit}
      defaultValues={data}
      isSubmitting={isSubmitting}
    />
  );
};
